<template>
  <div class="reassign-reports">
    <h1>Reassign Reports</h1>
    <div class="reassignment-form">
      <div class="form-elements">
        <UiTextbox
          v-model="reportId"
          label="Report ID"
        />
        <UiSelect
          name="Organization"
          v-model="org"
          :options="orgs || []"
          :loading="orgStatus === 'loading'"
          :error="orgError"
          :keys="{
            label: 'name',
          }"
        />
        <UiButton
          :loading="loading"
          raised
          @click="performReassign"
        >
          Reassign
        </UiButton>
        <div class="message">{{ message }}</div>
        <div class="error">{{ error }}</div>
      </div>
    </div>
    <OrphanedReports />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { UiTextbox, UiSelect, UiButton } from 'keen-ui';
import { sleep } from '@/utils';
import { reassignReport } from '@/store/modules/api';
import OrphanedReports from './OrphanedReports';

export default {
  name: 'ReassignReports',
  data() {
    return {
      reportId: null,
      org: null,
      loading: null,
      error: null,
      message: null,
    };
  },
  hagridActions: [
    'Orgs/fetch',
  ],
  computed: {
    ...mapState({
      orgs: state => state.Orgs.orgs,
      orgStatus: state => state.Orgs.status,
      orgError: state => state.Orgs.error,
    }),
  },
  methods: {
    async performReassign() {
      if (!this.reportId || !this.org || !this.org.id) {
        this.error = 'Form is not complete';
        return;
      }
      this.loading = true;
      this.error = null;
      this.message = null;
      try {
        const { message } = await reassignReport(this.reportId, this.org.id);
        this.loading = false;
        this.message = message;
        await sleep(8000);
        this.message = null;
      } catch (e) {
        this.error = e;
        this.loading = false;
      }
    },
  },
  components: {
    UiTextbox,
    UiSelect,
    UiButton,
    OrphanedReports,
  },
};
</script>

<style lang="scss" scoped>
.reassign-reports {
  .reassignment-form {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    margin-bottom: 30px;
    &:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
    width: 100%;
    width: fit-content;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding: 2px 16px;
    > * {
      display: inline-block;
      margin: 10px 20px;
      width: 300px;
    }

    .error {
      color: red;
    }
    .success {
      color: green;
    }
    .ui-textbox, .ui-select {
      max-width: 350px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReassignReports.vue